import { useState, useEffect } from "react";
import { apiFetch } from "../context/AppContext";

export function useUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiFetch("/tenant/users?page=1&page_size=100&status=active");
        if (res.ok && !cancelled) {
          const data = await res.json();
          // PaginatedResponse wraps items under the 'items' key
          setUsers(Array.isArray(data?.items) ? data.items : []);
        }
      } catch {
        if (!cancelled) setUsers([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { users, loading };
}
